/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export function SheetRowClassActionsRepresentationFromJSON(json) {
    return SheetRowClassActionsRepresentationFromJSONTyped(json, false);
}
export function SheetRowClassActionsRepresentationFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        canCreate: json['canCreate'],
        canDeleteById: json['canDeleteById'],
        canDuplicate: json['canDuplicate'],
        canSearch: json['canSearch'],
        canFindAll: json['canFindAll'],
        canGetById: json['canGetById'],
        canUpdate: json['canUpdate'],
        canMove: json['canMove'],
    };
}
export function SheetRowClassActionsRepresentationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        canCreate: value.canCreate,
        canDeleteById: value.canDeleteById,
        canDuplicate: value.canDuplicate,
        canSearch: value.canSearch,
        canFindAll: value.canFindAll,
        canGetById: value.canGetById,
        canUpdate: value.canUpdate,
        canMove: value.canMove,
    };
}
